export { SponsoredTag } from './sponsored-tag';
